import React, {ChangeEvent, memo, useCallback, useState} from "react"
import {useMessage} from "../../../../hooks/message"
import {useLocalization} from "../../../../hooks/localization"
const FileUpload = memo(function ({onFileUpload}: {onFileUpload: (file: File) => void}) {
    const [, setSelectedFile] = useState<File | null>(null)
    const {t} = useLocalization()
    const {failure} = useMessage()
    const isFileValid = useCallback((file: File): boolean => ["image/jpeg", "image/jpg"].includes(file.type), [])
    const handleFileChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files
            if (files && files.length > 0) {
                const file = files[0]
                if (isFileValid(file)) {
                    setSelectedFile(file)
                    onFileUpload(file)
                } else {
                    failure(t("media_upload_error"))
                }
            }
        },
        [t, failure, onFileUpload, isFileValid]
    )
    return (
        <div className="upload_field">
            <input type="file" onChange={handleFileChange} accept="image/*" id="actual-btn" hidden />
            <label htmlFor="actual-btn">{t("upload")}</label>
        </div>
    )
})

export default FileUpload
